export const GET_DISTRIBUTOR_CODES = 'GET_DISTRIBUTOR_CODES';
export const GET_DISTRIBUTOR_CODES_SUCCESS = 'GET_DISTRIBUTOR_CODES_SUCCESS';

export const GET_IFSC_DETAILS_SUCCESS = 'GET_IFSC_DETAILS_SUCCESS';
export const GET_IFSC_DETAILS = 'GET_IFSC_DETAILS';

export const GET_DISTRIBUTORS_SUCCESS = 'GET_DISTRIBUTORS_SUCCESS';
export const GET_DISTRIBUTORS = 'GET_DISTRIBUTORS';

export const GET_RMS = 'GET_RMS';
export const GET_RMS_SUCCESS = 'GET_RMS_SUCCESS';

export const GET_Countries_SUCCESS = 'GET_Countries_SUCCESS';
export const GET_Countries = 'GET_Countries';

export const GET_BANK_DETAILS_FROM_CHEQUE_SUCCESS = 'GET_BANK_DETAILS_FROM_CHEQUE_SUCCESS';
export const GET_BANK_DETAILS_FROM_CHEQUE = 'GET_BANK_DETAILS_FROM_CHEQUE';

export const GET_MASKED_AADHAR_DETAILS_SUCCESS = 'GET_MASKED_AADHAR_DETAILS_SUCCESS';
export const GET_MASKED_AADHAR_DETAILS = 'GET_MASKED_AADHAR_DETAILS';

export type IfscType = {
  BankAdd1: string;
  BankAdd2: string;
  BankAdd3: string;
  BankCity: string;
  BankName: string;
  BankPin: number;
  IFSCCode: string;
  IFSCOwnedBank: string;
  MicrNo: string;
};
export type mdmsCountriesList = {
  name: string;
  dial_code: string;
  code: string;
  nationality: string;
};
export type nationaliyType = {
  countries: mdmsCountriesList[];
};

export const GET_DISTRIBUTORS_FOR_FILTERS_SUCCESS = 'GET_DISTRIBUTORS_FOR_FILTERS_SUCCESS';
export const GET_DISTRIBUTORS_FOR_FILTERS = 'GET_DISTRIBUTORS_FOR_FILTERS';

export const GET_JOINTHOLDERLIST_SUCCESS = 'GET_JOINTHOLDERLIST_SUCCESS';
export const GET_JOINTHOLDERLIST = 'GET_JOINTHOLDERLIST';

export const GET_RISKPROFILEMDMS_SUCCESS = 'GET_RISKPROFILEMDMS_SUCCESS';
export const GET_RISKPROFILEMDMS = 'GET_RISKPROFILEMDMS';

export const GET_STATES_SUCCESS = 'GET_STATES_SUCCESS';
export const GET_STATES = 'GET_STATES';

export const GET_CUSTODIAN_CONFIG_SUCCESS = 'GET_CUSTODIAN_CONFIG_SUCCESS';
export const GET_CUSTODIAN_CONFIG = 'GET_CUSTODIAN_CONFIG';

export const GET_CUSTODIAN_MASTER_SUCCESS = 'GET_CUSTODIAN_MASTER_SUCCESS';
export const GET_CUSTODIAN_MASTER = 'GET_CUSTODIAN_MASTER';

export const GET_VALIDATIONORCONFIGMASTER_SUCCESS = 'GET_VALIDATIONORCONFIGMASTER_SUCCESS';
export const GET_VALIDATIONORCONFIGMASTER = 'GET_VALIDATIONORCONFIGMASTER';

export type applicationDependantChangesType = { [key: string]: string[] };

export type mdmsStatesList = {
  name: string;
  code: string;
};

export type statesType = {
  states: mdmsStatesList[];
};

export type ValidationOrConfigMaster = {
  [key: string]: string;
};
